require('./style.scss');
var tmpl = require('./main.ejs');

module.exports = function (data) {
  // @todo 需要对data进行clone，否则会污染全局下的config.info
  data = $.extend(true, {}, data);
  // data.start_time_view = formatDate(data.start_date);
  return tmpl(data);
};






// WEBPACK FOOTER //
// ./app/modules/header/index.js